<template>
  <div class="grid-view">
    <div class="main-content">
      <div class="triggers" style="margin: 10px">
        <span v-if="!!title" class="title" style="margin-right: 10px;">{{ title }}</span>
        <el-button :disabled="!innerIsEditing || slaveCustomsDeclarationEnable" type="primary" no="1" @click="showEditDialog(true)">{{ $t('SeaExport.NewGoods') }}</el-button>
        <el-button :disabled="!innerIsEditing || slaveCustomsDeclarationEnable" type="danger" no="2" @click="remove">{{ $t('SeaExport.DeleteGoods') }}</el-button>
        <div class="calculation" style="float: right">
          <label>{{ $t('SeaExport.TotalOfThisBox') }}</label>
          <span>{{ $t('SeaExport.Quantity') }}：{{ quantity }}</span>
          <span>{{ $t('SeaExport.Weight') }}：{{ weight }}</span>
          <span>{{ $t('SeaExport.Cubage') }}：{{ cubage }}</span>
        </div>
      </div>
      <div class="section grid-wrapper">
        <cargo-ag-grid
          config-module="13011501"
          :grid-options="gridOptions"
          :column-defs="columnDefs"
          :row-data="finalRowData"
          style="width:100%;height:200px;margin-top:5px"
          @gridReady="onGridReady"
        />
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-input v-model="advanceTextDialog.value" :disabled="!isEditing" type="textarea" rows="10" no="3" />
      <span slot="footer">
        <el-button v-show="isEditing" type="primary" no="4" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="5"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import CargoAgGridCommonInputEditor from '@/components/Cargo/Common/CargoAgGridCommonInputEditor'
import CargoAgGridCommonTextareaEditor from '@/components/Cargo/Common/CargoAgGridCommonTextareaEditor'
import { roundHalfUp } from '@/utils/commonUtil'
import ContainerNoHelper from '@/utils/containerNoHelper'
import ColumnUtils from '@/utils/ColumnUtils'
import { AutoIncrementNum } from '@/utils/commonUtil'
import { SeaExportJob } from '@/class/model/booking/SeaExportJob'
import { ManifestGoodsInfo } from '@/class/model/booking/ManifestGoodsInfo'
import URL from '@/api/urlTranslator'
import { SEUtils } from '@/class/cargo/model/utils/SEUtils'
import { PoItems } from '@/class/model/booking/PoItems'
import CargoAgGridAdvanceSelectEditor from '@/components/Cargo/Common/CargoAgGridAdvanceSelectEditor'
import StrUtils from '@/utils/StrUtils'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'

export default {
  name: 'BookingManifestGoodsInfo',
  components: {
    CargoAgGridAdvanceSelectEditor
  },
  props: {
    job: { type: Object, required: true },
    isEditing: { type: Boolean, required: true },
    isOrNotDisplaySoNo: { type: Boolean, default: false },
    isAddSpelling: { type: Boolean, default: false },
    delPoItemsUuids: { type: Array, default: () => [] },
    slaveCustomsDeclarationEnable: { // 【小票】关单信息 是否可用
      type: Boolean,
      default: false
    },
    isUppercaseByConfig: { type: Boolean, default: true },
    title: { type: String, default: '' },
    elementDict: { type: Object, default: null }
  },
  data() {
    return {
      manifestGoods: {},
      URL,
      roundHalfUp,
      ColumnUtils,
      quantity: 0,
      weight: 0.00,
      cubage: 0.00,
      gridOptions: {
        rowSelection: 'multiple',
        singleClickEdit: true,
        suppressCellSelection: true,
        // 选中 勾选框或者其他列 都会触发
        /* onCellFocused: (event) => {
          this.onGridCellFocused(event)
        }, */
        // 选中 勾选框触发
        onRowSelected: (event) => {
          this.onGridRowSelected(event)
        },
        onRowClicked: this.onRowClicked,
        frameworkComponents: {
          CargoAgGridAdvanceSelectEditor,
          CargoAgGridCommonInputEditor,
          CargoAgGridCommonTextareaEditor
        },
        context: {
          componentParent: this
        }
      },
      rowData: [],
      gridApi: null,
      selectedRow: null,
      autoIncrementNum: new AutoIncrementNum(),
      containerNoClass: '',
      editDialog: {
        visible: false,
        title: '',
        form: new ManifestGoodsInfo().fillDefaultValue().getData()
      },
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null
      },
      delRowList: [],
      poItems: []
    }
  },
  computed: {
    innerIsEditing() {
      return this.isEditing
    },
    columnDefs() {
      let columnDefs = [
        {
          headerName: '',
          field: '',
          width: 65,
          headerCheckboxSelection: true,
          checkboxSelection: true,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false
        },
        {
          headerName: this.$t('SeaExport.SoNo'),
          field: 'soNo',
          colId: 'soNo',
          width: 100,
          editable: this.isEditing && !this.slaveCustomsDeclarationEnable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            multiplePaste: {}
          }
        },
        // {
        //   headerName: this.$t('queryJob.englishDescriptionOfGoods'),
        //   colId: 'cargoEnglishName',
        //   field: 'cargoEnglishName',
        //   width: 100,
        //   editable: this.isEditing,
        //   cellEditor: 'CargoAgGridCommonTextareaEditor'
        // },
        {
          headerName: this.$t('SeaExport.EnglishDescriptionOfGoods'),
          colId: 'englishCommodity',
          field: 'englishCommodity',
          width: 100,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          cellEditorParams: {
            autoUppercase: this.isUppercaseByConfig
          }
        }, {
          headerName: this.$t('SeaExport.Marks'),
          colId: 'mark',
          field: 'mark',
          width: 100,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonTextareaEditor',
          cellEditorParams: {
            autoUppercase: this.isUppercaseByConfig
          }
        }, {
          headerName: 'HSCode',
          colId: 'hsCode',
          field: 'hsCode',
          width: 100,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }, {
          headerName: this.$t('SeaExport.Package'),
          colId: 'packing',
          field: 'packing',
          width: 100,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridAdvanceSelectEditor',
          cellEditorParams: {
            selectProps: {
              selectType: TYPE_NAMES.basic_data_Packing,
              filterable: true,
              tagValue: 'code',
              customLabel: (item) => this.language === 'zh' ? `${item.chineseName}[${item.name}]` : `${item.name}[${item.chineseName}]`,
              showCustomLabelInOption: true
            }
          }
        }, {
          headerName: this.$t('SeaExport.Quantity'),
          colId: 'quantity',
          field: 'quantity',
          width: 100,
          editable: this.isEditing && !this.slaveCustomsDeclarationEnable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              min: 0,
              precision: 0
            },
            multiplePaste: { isNumber: true, precision: 0 }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Weight'),
          colId: 'grossWeight',
          field: 'grossWeight',
          width: 100,
          valueFormatter: params => {
            return (Number(params.value) || 0).toFixed(3)
          },
          editable: this.isEditing && !this.slaveCustomsDeclarationEnable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              min: 0,
              precision: 3
            },
            multiplePaste: { isNumber: true, precision: 3, min: 0 }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: this.$t('SeaExport.Cubage'),
          colId: 'cubage',
          field: 'cubage',
          width: 100,
          valueFormatter: params => {
            return (Number(params.value) || 0).toFixed(3)
          },
          editable: this.isEditing && !this.slaveCustomsDeclarationEnable,
          cellEditor: 'CargoAgGridCommonInputEditor',
          cellEditorParams: {
            isNumber: true,
            inputProps: {
              min: 0,
              precision: 3
            },
            multiplePaste: { isNumber: true, precision: 3, min: 0 }
          },
          onCellValueChanged: p => this.onCellChange(p)
        }, {
          headerName: 'CUS CODE',
          colId: 'cusCode',
          field: 'cusCode',
          width: 100,
          editable: this.isEditing,
          cellEditor: 'CargoAgGridCommonTextareaEditor'
        }
      ]
      if (this.elementDict) {
        columnDefs = UICustomUtil.handleColumnLabelAndDisplay(columnDefs, this.elementDict)
      }
      return columnDefs
    },
    finalRowData() {
      return this.rowData.filter(p => p && !p.deleted)
    }
  },
  methods: {
    checkModels(tabName) {
      if (!this.rowData || this.rowData.length <= 0) return
      for (const item of this.rowData) {
        this.checkModel(item, tabName)
      }
    },
    beforeUpload(file) {
      var fileType = file.name.substring(file.name.lastIndexOf('.') + 1)
      const extension = fileType === 'xls'
      const extension2 = fileType === 'xlsx'
      if (!extension && !extension2) {
        this.$message.warning(this.$t('SeaExport.FileOnlyXlsXlsx'))
      }
      return extension || extension2
    },
    uploadSuccess(response, file, fileList) {
      if (response && response.data) {
        this.saveImportData(response.data)
      } else {
        this.$message.warning(this.$t('SeaExport.ImportFailedContactAdministrator'))
      }
    },
    saveImportData(item) {
      const oldNum = SEUtils.getQuantity(this.job)
      const manifestInfo = this.manifestInfo
      const manifestGoods = manifestInfo.manifestGoods
      manifestGoods.push(...item.manifestGoods)
      if (SEUtils.needTip(this.job, 'SONO')) {
        const newNum = SEUtils.getQuantity(this.job)
        if (oldNum !== newNum) {
          this.$confirm(this.$t('CargoMsg.Cargo_SoNoChangeTips'), this.$t('CargoMsg.Cargo_Tips'), {
            confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
            cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
            type: 'warning'
          }).then(async() => {
            this.$emit('soNoChange', newNum)
          })
        }
      }
    },
    // 选中 勾选框或者其他列 都会触发[获取选中行]
    onGridCellFocused(event) {
      if (!event) return
      this.selectedRow = null
      if (this.gridApi && event.column) {
        this.gridApi.forEachNode(node => {
          if (node && node.rowIndex === event.rowIndex && node.data) {
            this.selectedRow = node.data
          }
        })
      }
    },
    onGridRowSelected(event) {
      if (!event || !event.data) return
      this.selectedRow = null
      if (event.node.isSelected()) {
        this.selectedRow = event.data
      }
    },
    // 行点击触发事件
    onRowClicked(event) {
      if (!event || !event.data) return
      this.selectedRow = event.data
    },
    onGridReady(params) {
      this.gridApi = params.api
    },
    async init(data) {
      // 编辑同一笔数据不重新加载
      this.manifestGoods = data
      this.rowData = []
      if (Object.keys(this.manifestGoods).length > 0) {
        this.rowData = this.rowData.concat(this.manifestGoods.poItems)
        this.refTotal()
      }
    },
    // 列编辑修改事件
    onCellChange(params) {
      const { node, colDef } = params
      const newValue = Number(params.newValue) || 0
      if (newValue < 0) {
        switch (colDef.field) {
          case 'quantity':
            node.setDataValue(colDef.colId || colDef.field, '0')
            break
          case 'grossWeight':
          case 'cubage':
            node.setDataValue(colDef.colId || colDef.field, '0.000')
            break
        }
      }
      this.calculation(colDef.field)
    },
    // 列编辑修改事件
    onCellChange2(params) {
      const { colDef } = params
      if (colDef.field && colDef.field === 'soNo') {
        this.soNoChangeHandler()
      }
    },
    soNoChangeHandler() {
      if (SEUtils.needTip2(this.job, 'SONO')) {
        this.$confirm(this.$t('CargoMsg.Cargo_SoNoChangeTips'), this.$t('CargoMsg.Cargo_Tips'), {
          confirmButtonText: this.$t('CargoMsg.Cargo_Confirm'),
          cancelButtonText: this.$t('CargoMsg.Cargo_Cancel'),
          type: 'warning'
        }).then(async() => {
          this.$emit('soNoChange', SEUtils.getQuantity(this.job))
        })
      }
    },
    showEditDialog() {
      const poItems = new PoItems().fillDefaultValue().getData()
      poItems.purchaseCurrency = 'USD'
      poItems.deviceStatus = 0
      poItems.productiveYear = '不详'
      poItems.newOrUsed = ''
      poItems.jobUuid = this.job.uuid
      poItems.sequenceNo = this.poItems.length > 0 ? this.poItems.length + 1 : 1
      poItems.containerNo = this.manifestGoods.containerNo
      poItems.eqSize = this.manifestGoods.eqSize
      poItems.eqType = this.manifestGoods.eqType
      poItems.sealNo = this.manifestGoods.sealNo
      poItems.related = 1
      poItems.containerUsageKey = this.manifestGoods.uuid
      if (!this.manifestGoods.poItems) {
        this.manifestGoods.poItems = []
      }
      this.manifestGoods.poItems.push(poItems)
      this.rowData.push(poItems)
    },
    showAdvanceTextDialog(title, value, successCallback) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.visible = true
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    fillModel() {
      if (!this.isOrNotDisplaySoNo && this.rowData && this.rowData.length > 0) {
        for (const item of this.rowData) {
          item.soNo = null // 加拼业务，货物信息关单号为null
        }
      }
    },
    checkModel(form, tabName) {
      if (!this.isAddSpelling && !form.soNo && this.isOrNotDisplaySoNo) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheNoCannotBeBlank')}`, tabName)
        return
      }
      if (!form.containerNo) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.CaseNumberCannotBeEmpty')}`, tabName)
        return
      }
      // 不做强制要求
      /* if (!ContainerNoHelper.checkContainerNo(form.containerNo)) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.InvalidCaseNumber')}`, tabName)
      }*/
      if (!form.sealNo) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheSealNumberCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.eqSize) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.BoxTypeCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.cargoEnglishName) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.EnglishNameCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.mark) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.TheMarkCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.hsCode) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.HscodeCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.packing) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.ThePackageCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.quantity || Number(form.quantity) <= 0) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.ThePiecesCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.weight || Number(form.weight) <= 0) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.GrossWeightCannotBeEmpty')}`, tabName)
        return
      }
      if (!form.cubage || Number(form.cubage) <= 0) {
        this.$message.warning(`【${this.$t('SeaExport.CargoInfo')}】${this.$t('SeaExport.VolumeCannotBeEmpty')}`, tabName)
        return
      }
    },
    async getSubmitData() {
      /* await poItemsUpdate(this.associatePoItems) */
      return {
        delPoItemsUuids: this.delPoItemsUuids
      }
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows && rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      for (const item of rows) {
        if (item.uuid) {
          item.eqSize = null
          item.eqType = null
          item.containerNo = null
          item.sealNo = null
          item.related = 0
          item.containerUsageKey = null
          this.delPoItemsUuids.push(item.uuid)
        }
        const poItems = this.manifestGoods.poItems
        const index = poItems.findIndex(p => p === item)
        poItems.splice(index, 1)
        const key = this.rowData.findIndex(p => p === item)
        this.rowData.splice(key, 1)
      }
      this.$nextTick(() => {
        this.calculation()
      })
    },
    // 当装箱记录被删除时调用
    removeAll() {
      this.removePoItems()
      this.manifestGoods.poItems = []
      this.rowData = []
      this.$nextTick(() => {
        this.calculation()
      })
      // this.gridOptions.api.setRowData(this.finalRowData)
    },
    removePoItems() {
      const poItems = this.manifestGoods.poItems
      if (poItems) {
        poItems.forEach(item => {
          if (!StrUtils.isEmpty(item.uuid)) {
            this.delPoItemsUuids.push(item.uuid)
          }
        })
      }
      this.clear()
    },
    clear() {
      this.rowData = []
      this.quantity = 0
      this.weight = roundHalfUp(0, 3)
      this.cubage = roundHalfUp(0, 3)
    },
    containerNbrStyleFunction(data) {
      if (!ContainerNoHelper.checkContainerNo(data.containerNo)) {
        return { color: '#FF0000' }
      }
      return { color: '' }
    },
    // 修改件毛体
    calculation(colId, noChange) {
      let quantity = 0
      let cubage = 0
      let weight = 0
      switch (colId) {
        case 'quantity':
          this.finalRowData.forEach(eve => {
            if (eve.quantity == '') {
              eve.quantity = 0
            }
            quantity += parseInt(eve.quantity)
          })
          this.quantity = quantity
          break
        case 'grossWeight':
          this.finalRowData.forEach(eve => {
            if (eve.grossWeight == '') {
              eve.grossWeight = 0.00
            }
            weight += parseFloat(eve.grossWeight)
          })
          this.weight = roundHalfUp(weight, 3)
          break
        case 'cubage':
          this.finalRowData.forEach(eve => {
            if (eve.cubage == '') {
              eve.cubage = 0.00
            }
            cubage += parseFloat(eve.cubage)
          })
          this.cubage = roundHalfUp(cubage, 3)
          break
        default:
          this.finalRowData.forEach(eve => {
            if (eve.quantity == '') {
              eve.quantity = 0
            }
            if (eve.cubage == '') {
              eve.cubage = 0.00
            }
            if (!eve.grossWeight) {
              eve.grossWeight = 0.00
            }
            weight += parseFloat(eve.grossWeight)
            cubage += parseFloat(eve.cubage)
            quantity += parseInt(eve.quantity)
          })
          this.quantity = quantity
          this.weight = roundHalfUp(weight, 3)
          this.cubage = roundHalfUp(cubage, 3)
      }
      this.manifestGoods.quantity = this.quantity
      this.manifestGoods.weight = this.weight
      this.manifestGoods.cubage = this.cubage
      if (!noChange) {
        // 会联动同步修改装箱信息的件毛体
        this.$emit('change', this.manifestGoods)
      }
    },
    // 加载货物明细时，需要重新计算件毛体合计
    refTotal() {
      let quantity = 0
      let cubage = 0
      let weight = 0
      this.finalRowData.forEach(eve => {
        if (eve.quantity == '') {
          eve.quantity = 0
        }
        if (eve.cubage == '') {
          eve.cubage = 0.00
        }
        if (!eve.grossWeight) {
          eve.grossWeight = 0.00
        }
        weight += parseFloat(eve.grossWeight)
        cubage += parseFloat(eve.cubage)
        quantity += parseInt(eve.quantity)
      })
      this.quantity = quantity
      this.weight = roundHalfUp(weight, 3)
      this.cubage = roundHalfUp(cubage, 3)
    }
  }
}
</script>
<style lang="scss" scoped>
.triggers{
  justify-content: space-between !important;
  .calculation{
    padding: 0 20px !important;
    span{
      margin-left: 5px;
    }
  }
}
</style>
